module.exports.AUTHENTICATION = "snAuthCookie";



// WEBPACK FOOTER //
// ./common/constants/cookies.js